import * as ko from 'knockout';

import { Instance as companyService } from '@/legacy/services/company';
import { Instance as userService } from '@/legacy/services/user';
import { Instance as verificationService } from '@/legacy/services/verification/verification';
import { Instance as verificationUserService } from '@/legacy/services/verification/verificationUser';

export const companyOnboardingStatus = companyService.CompanyId.mapAsync((companyId) => {
  if (!companyId) {
    return undefined;
  }
  return new Promise((resolve, reject) => {
    verificationService
      .getOnboardingWizardStatus(companyId)
      .then((result) => resolve(result.companyVerificationStatus))
      .fail(reject);
  });
});

export const isCompanyVerificationCompleted = ko.pureComputed(
  () => companyOnboardingStatus() === 'COMPLETED'
);

export const isCompanyVerificationInProgress = ko.pureComputed({
  read: () =>
    companyOnboardingStatus() !== null &&
    companyOnboardingStatus() !== 'COMPLETED' &&
    companyOnboardingStatus() !== 'REJECTED',
});

export const isUnableToVerifyCompany = ko.pureComputed(
  () => companyOnboardingStatus() === 'REJECTED'
);

const companyAndUserId = ko.computed(() => [companyService.CompanyId(), userService.UserId()]);

export const userOnboardingStatus = companyAndUserId.mapAsync(
  ([companyId, userId]) =>
    companyId &&
    userId &&
    Promise.resolve(verificationUserService.GetVerifyIdentityStatus(companyId, userId))
);

/** Backing field for {@see identityVerified} */
const identityVerifiedHack = ko.observable<boolean | undefined>(undefined);

/**
 * Identity verification doesn't trigger any app invalidations. SignalR doesn't fire a user updated
 * event. We do some hacking to pretend that all that stuff worked.
 */
export const identityVerified = ko.pureComputed<boolean>({
  read: () => identityVerifiedHack() ?? userService.profile()?.identityVerified(),
  write: identityVerifiedHack,
  deferEvaluation: true,
});

/** Backing field for {@see identitySubmitted} */
const identitySubmittedHack = ko.observable<boolean | undefined>(undefined);

/**
 * Identity verification doesn't trigger any app invalidations. SignalR doesn't fire a user updated
 * event. We do some hacking to pretend that all that stuff worked.
 */
export const identitySubmitted = ko.pureComputed<boolean>({
  read: () =>
    identityVerified() || (identitySubmittedHack() ?? userService.profile()?.isIdentitySubmitted()),
  write: identitySubmittedHack,
  deferEvaluation: true,
});

export const isUnableToVerifyIdentity = ko.pureComputed(
  () => userOnboardingStatus()?.status === 'REJECTED'
);

export const isOnboardingCompleted = ko.pureComputed(
  () => isCompanyVerificationCompleted() && identityVerified() && !isUnableToVerifyIdentity()
);

export const isUnableToVerify = ko.pureComputed(
  () => isUnableToVerifyIdentity() || isUnableToVerifyCompany()
);
